module.exports = __webpack_public_path__ + "img/logo.7d4ee55b.png";